import { render, staticRenderFns } from "./WheelOfFortune.vue?vue&type=template&id=1f949574&scoped=true"
import script from "./WheelOfFortune.vue?vue&type=script&lang=js"
export * from "./WheelOfFortune.vue?vue&type=script&lang=js"
import style0 from "./WheelOfFortune.vue?vue&type=style&index=0&id=1f949574&prod&lang=scss&scoped=true"
import style1 from "./WheelOfFortune.vue?vue&type=style&index=1&id=1f949574&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f949574",
  null
  
)

export default component.exports